
export default {
  name: 'VsGridRow',
  props: {
    inline: {
      type: [Boolean, Object],
      default: false
    },
    columns: {
      type: [String, Number, Object],
      default: null
    },
    gap: {
      type: [Boolean, String, Number, Object],
      default: null
    },
    autoFlow: {
      type: [String, Object],
      default: null
    },
    autoFit: {
      type: [String, Object],
      default: null
    },
    autoFill: {
      type: [String, Object],
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    default: {
      $attrs: 'all',
      $columns: 'gridColumns',
      $gap: 'gridGap',
      $autoFlow: 'gridAutoFlow',
      $autoFit: 'gridAutoFit',
      $autoFill: 'gridAutoFill',
      $inline: {
        display(value) {
          return value ? 'inline-grid' : 'grid'
        }
      }
    }
  }
}
